import React, { ReactNode } from "react";
import { PaymentContextProvider } from "./PaymentContextProvider";
import { UserContextProvider } from "./UserContextProvider";

export const AppContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <UserContextProvider>
      <PaymentContextProvider>{children}</PaymentContextProvider>
    </UserContextProvider>
  );
};
